import React from 'react';
import { useTranslation } from 'react-i18next';

import logoFacebook from '../../_assets/logos/facebook.svg';
import logoGoogle from '../../_assets/logos/google.svg';
import logoTwitch from '../../_assets/logos/twitch.svg';

import { FacebookButton } from './facebook-button/FacebookButton';
import { GoogleButton } from './google-button/GoogleButton';
import { TwitchButton } from './twitch-button/TwitchButton';

export interface ProviderUserInfo {
  idToken: string;
  email: string;
  firstName?: string;
  lastName?: string;
  nickName?: string;
}

export interface ProviderResponse {
  type: string;
  user: ProviderUserInfo;
  otp?: string;
}

interface Props {
  textBtn: string;
}

export function Providers(props: Props): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className='flex-column align-items-center provider-authentication-container'>
      <FacebookButton>
        <>
          <img src={logoFacebook} alt='Facebook Logo' height='24' />
          {t(`${props.textBtn}.facebook`)}
        </>
      </FacebookButton>
      <GoogleButton>
        <>
          <img src={logoGoogle} alt='Google Logo' height='24' />
          {t(`${props.textBtn}.google`)}
        </>
      </GoogleButton>
      <TwitchButton>
        <>
          <img src={logoTwitch} alt='Twitch Logo' height='24' />
          {t(`${props.textBtn}.twitch`)}
        </>
      </TwitchButton>
    </div>
  );
}
